import { ScrollView, StyleSheet, View } from 'react-native'
import { AccountSection } from '@/src/app/main/(tabs)/card/card-management/_common/AccountSection'
import { Loading } from '@/src/common/components/Loading'
import { triggerSegmentAction } from '@/src/services/segment'
import { useAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import { useLogError } from '@/src/common/hooks/useLogError'
import {
  useCardManagementStackScreensAreModals,
  useCardStackScreen,
} from '@/src/app/main/(tabs)/card/card-management/_common/cardStackScreen'
import { withPaymentMethodsForCardManagement } from '@/src/experiences/card-payments/providePaymentMethods/withPaymentMethodsForCardManagement'

export function useAccountsScreenProps() {
  const cardManagementStackScreensAreModals = useCardManagementStackScreensAreModals()
  return useCardStackScreen({
    name: 'accounts',
    options: {
      title: 'Accounts',
      presentation: cardManagementStackScreensAreModals ? 'transparentModal' : 'modal',
      contentStyle: { paddingHorizontal: 16 },
    },
  })
}

export default withPaymentMethodsForCardManagement(function Accounts({
  data,
  loading,
  closePaymentMethod,
  closingPaymentMethod,
  openPlaidLink,
  plaidLinkLoading,
}) {
  const Alert = useAlert(Accounts.name)
  const onError = useLogError()
  const { Modal } = useAccountsScreenProps()
  const cardManagementStackScreensAreModals = useCardManagementStackScreensAreModals()

  return Modal({
    children: (
      <ScrollView
        contentContainerStyle={styles.accountSection}
        style={cardManagementStackScreensAreModals && { padding: 24, paddingTop: 0 }}
      >
        <AccountSection
          sectionName="Bank Accounts"
          accounts={data}
          onAddNewPress={() => {
            void triggerSegmentAction({
              component: 'Button',
              action:
                'User Opened Plaid Integration in order to add an external bank account on the Card Management page',
            })
            void openPlaidLink?.()
          }}
          onDeletePress={(account) => {
            Alert.alert(
              'Delete External Bank Account',
              'Are you sure you want to delete this external bank account?',
              [
                { text: 'Cancel', style: 'cancel' },
                {
                  text: 'Delete',
                  style: 'destructive',
                  onPress() {
                    void triggerSegmentAction({
                      component: 'Button',
                      action:
                        'User Pressed the "Delete" button to delete an external bank account on the Card Management page',
                    })
                    closePaymentMethod?.(account)
                  },
                },
              ],
            )
          }}
          onVerifyPress={(account) => {
            void triggerSegmentAction({
              component: 'Button',
              action:
                'User Pressed the "Verify" button to verify an external bank account on the Card Management page',
            })

            if (openPlaidLink?.(account)) {
              return
            }

            Alert.alert(
              "We aren't able to verify this account at this time. Please try again later",
            )
            onError('plaidAccountId missing when attempting to verify account', account)
          }}
        />
        {(plaidLinkLoading || loading || closingPaymentMethod) && (
          <View style={styles.loadingStyle}>
            <Loading />
          </View>
        )}
      </ScrollView>
    ),
  })
})

const styles = StyleSheet.create({
  loadingStyle: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100%',
  },
  accountSection: {
    backgroundColor: 'white',
    borderRadius: 16,
    paddingVertical: 16,
  },
})
